import { IThreadModel } from './model';

export default (self: IThreadModel) => ({
  get isCompleted() {
    return self.status === 'completed';
  },
  get isProcessing() {
    return self.status === 'processing';
  },
  // True only once the backend has reported token usage for this thread. Threads
  // created before token tracking have total_tokens === null and hide the gauge.
  get hasTokenData() {
    return self.total_tokens != null;
  },
  get tokenPercentage() {
    if (self.total_tokens == null || !self.token_limit) return 0;
    return Math.min(100, Math.max(0, (self.total_tokens / self.token_limit) * 100));
  },
  get isNearLimit() {
    if (self.total_tokens == null || !self.token_limit) return false;
    return self.total_tokens / self.token_limit >= 0.8;
  },
  get isAtLimit() {
    // token_limit === 0 means the cap is disabled server-side; null usage = untracked.
    return self.total_tokens != null && self.token_limit > 0 && self.total_tokens >= self.token_limit;
  },
  get hasAttachedFiles() {
    return self.attachedFiles.length > 0;
  },
  get isUploadingFile() {
    return self.uploadingCount > 0;
  }
});
